import i18n from '@/i18n';
import { validityLabel, validityState, VALIDITY_STATES } from '@modules/logic/dailyTripValidity';

import AppStatusChip from '../buttons/AppStatusChip';

/**
 * Aspetto per stato. `active` resta volutamente in grigio: è il caso normale, e
 * colorarlo toglierebbe risalto ai tre che invece vanno notati.
 */
const STATE_META = {
  [VALIDITY_STATES.ACTIVE]: {
    label: i18n.t('in_servizio', { defaultValue: 'In servizio' }),
    variant: 'neutral',
    icon: 'circle-check',
  },
  [VALIDITY_STATES.SCHEDULED]: {
    label: i18n.t('programmato', { defaultValue: 'Programmato' }),
    variant: 'info',
    icon: 'calendar-plus',
  },
  [VALIDITY_STATES.EXPIRED]: {
    label: i18n.t('scaduto', { defaultValue: 'Scaduto' }),
    variant: 'warning',
    icon: 'calendar-xmark',
  },
  [VALIDITY_STATES.ARCHIVED]: {
    label: i18n.t('archiviato', { defaultValue: 'Archiviato' }),
    variant: 'neutral',
    icon: 'box-archive',
  },
};

/**
 * ValidityCell — stato + periodo di validità di un pianificato.
 *
 * I `giorni` di un pianificato dicono la cadenza settimanale, `start_date` /
 * `end_date` da quando a quando: senza vederle, due giri identici sulla stessa
 * tratta sono indistinguibili anche quando uno è storia chiusa e l'altro è
 * quello in servizio. Da qui la coppia stato + periodo nella stessa cella.
 *
 * @param {object} props.trip il pianificato
 * @param {*} [props.day] giorno di riferimento (default: oggi)
 */
export default function ValidityCell({ trip, day, showLabel = true }) {
  const state = validityState(trip, day);
  const meta = STATE_META[state] || STATE_META[VALIDITY_STATES.ACTIVE];
  const period = validityLabel(trip);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, overflow: 'hidden' }}>
      {showLabel && <AppStatusChip variant={meta.variant} icon={meta.icon} label={meta.label} />}
      {/* Un periodo vuoto significa "sempre valido": non si inventa un trattino
          che sembrerebbe un dato mancante. */}
      {period && (
        <span className="cell-muted" style={{ fontSize: 11 }}>
          {period}
        </span>
      )}
    </div>
  );
}
